module.exports = __webpack_public_path__ + "static/img/products discription_pu2.2a26d8d9.jpg";